/* eslint @typescript-eslint/no-explicit-any: "off" */

import {
    getJSON as getJSONBase,
    getXML as getXMLBase,
    postJSON as postJSONBase,
    postVoid as postVoidBase,
    postXML as postXMLBase,
    putJSON as putJSONBase,
    remove as removeBase,
} from "./base"
import { Receiver } from "../models/api/api"

const apiPath = "ConnectApi"

export const getJSON = (
    path: string,
    args?: any,
    receiver?: Receiver,
): Promise<any> =>
    getJSONBase(`${apiPath}/${path}`, args, new Headers(), receiver)

export const getXML = (
    path: string,
    args?: any,
    receiver?: Receiver,
): Promise<any> =>
    getXMLBase(`${apiPath}/${path}`, args, new Headers(), receiver)

export const postJSON = (
    path: string,
    args?: any,
    receiver?: Receiver,
): Promise<any> => {
    return postJSONBase(`${apiPath}/${path}`, args, new Headers(), receiver)
}

export const postVoid = (path: string, receiver?: Receiver): Promise<any> => {
    return postVoidBase(`${apiPath}/${path}`, new Headers(), receiver)
}

export const postXML = (
    path: string,
    args?: any,
    receiver?: Receiver,
): Promise<any> => {
    return postXMLBase(`${apiPath}/${path}`, args, new Headers(), receiver)
}

export const putJSON = (
    path: string,
    args?: any,
    receiver?: Receiver,
): Promise<any> => {
    return putJSONBase(`${apiPath}/${path}`, args, new Headers(), receiver)
}

export const remove = (
    path: string,
    args?: any,
    receiver?: Receiver,
): Promise<any> =>
    removeBase(`${apiPath}/${path}`, args, new Headers(), receiver)
